import { Table, TableCard } from "@introist/react-foundation/v2";
import styled from "styled-components";
import { useLocalStorage } from "usehooks-ts";

const FullTable = styled(Table)`
  td {
    max-width: initial !important;
  }
`;

interface CategoryMetrics {
  category: string;
  activations: number;
  stepsExecuted: number;
}

interface CategoryMetricsTableProps {
  categories: CategoryMetrics[];
}

export const CategoryMetricsTable = ({ categories }: CategoryMetricsTableProps) => {
  // Get ROI settings from localStorage (same as ROICalculator)
  const [minutesPerWorkflow] = useLocalStorage("analytics.roi.minutesPerWorkflow", "30");
  const [minutesPerStep] = useLocalStorage("analytics.roi.minutesPerStep", "5");
  const [costPerHour] = useLocalStorage("analytics.roi.costPerHour", "50");

  const columns = [
    { key: "category", title: "Category", sortable: true },
    { key: "activations", title: "Activations", sortable: true },
    { key: "stepsExecuted", title: "Steps Executed", sortable: true },
    { key: "timeSaved", title: "Time Saved (hours)", sortable: true },
    { key: "costSaved", title: "Cost Saved (€)", sortable: true }
  ];

  // Calculate ROI per category
  const workflow = parseFloat(minutesPerWorkflow) || 0;
  const step = parseFloat(minutesPerStep) || 0;
  const cost = parseFloat(costPerHour) || 0;

  // Format category names for display and add ROI calculations
  const formattedData = categories.map(cat => {
    const totalMinutes = cat.activations * workflow + cat.stepsExecuted * step;
    const timeSaved = parseFloat((totalMinutes / 60).toFixed(2));
    const costSaved = parseFloat((timeSaved * cost).toFixed(2));

    return {
      ...cat,
      category: cat.category
        .split("-")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      timeSaved: timeSaved.toLocaleString(),
      costSaved: `€${costSaved.toLocaleString()}`
    };
  });

  return (
    <TableCard style={{ overflowX: "auto" }}>
      <FullTable columns={columns} data={formattedData} />
    </TableCard>
  );
};
